import EcomPasetoAjax from '@square/dashboard-utilities/services/ecom-paseto-ajax';
export default class SquareSyncAjax extends EcomPasetoAjax {}